/**
 * Labstep
 *
 * @module screens/EntityView/Index/LeftPane
 * @desc EntityView Index LeftPane
 */

import { EntityViewFilterPane } from 'labstep-web/components/EntityView/Filter/Pane';
import { LayoutLeftPane } from 'labstep-web/components/Layout/LeftPane';
import type React from 'react';
import type { EntityViewIndexLeftPaneProps } from './types';

export const EntityViewIndexLeftPane: React.FC<
  EntityViewIndexLeftPaneProps
> = () => (
  <LayoutLeftPane>
    <EntityViewFilterPane />
  </LayoutLeftPane>
);
